import { useWarehouseLabels } from '../warehouseLabels';

/**
 * Rótulos da FÁBRICA (M6).
 *
 * ⚠️ Este arquivo NÃO tem dicionário próprio — e é de propósito. As 170 chaves
 * do M6 vivem em `warehouseLabels.js`, junto com as do resto do módulo, porque
 * a BANCADA e o CONSOLE falam do MESMO lote de produção: dois vocabulários
 * paralelos divergem no primeiro texto que alguém ajusta só de um lado (e a
 * convenção do projeto, CLAUDE.md §4, proíbe a duplicação).
 *
 * O que sobrou aqui é o que é REALMENTE da fábrica: a interpolação de valores
 * no meio da frase, que os rótulos de refugo e de virada de lote precisam.
 */
export function useProductionLabels() {
    return useWarehouseLabels();
}

/**
 * Interpolação mínima de `{campo}`. Existe porque partir a frase em pedaços
 * ("O refugo apontado", valor, "passou do teórico") congela a ORDEM das palavras
 * no JSX — e uma frase em português raramente tem a mesma ordem de outra língua.
 *
 * ⚠️ BUG CORRIGIDO nesta rodada: o padrão era `/{(w+)}/g` — sem a barra do
 * `\w`, o `w` virava um LITERAL, então a expressão casava `{w}`, `{ww}`… e
 * NENHUM `{code}`. Efeito medido: toda confirmação do M6 ("Cancelar a OP
 * {code}?", o aviso do lote de transição, os textos de refugo) chegava à tela
 * com a chave crua no lugar do valor. A classe de caractere estava escapada
 * errado, não a lógica.
 */
export function FormatLabel(template, values = {}) {
    return String(template ?? '').replace(/\{(\w+)\}/g, (match, key) => {
        const value = values?.[key];
        // Chave não informada fica como está: melhor um `{code}` visível na tela
        // (que denuncia o rótulo incompleto) do que um buraco silencioso.
        return value === undefined || value === null ? match : String(value);
    });
}
